import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import ServicesBento from "@/components/ServicesBento";
import DualClimateMode from "@/components/DualClimateMode";
import ThermalSimulator from "@/components/ThermalSimulator";
import StatsSection from "@/components/StatsSection";
import TestimonialsArea from "@/components/TestimonialsArea";
import Gallery from "@/components/Gallery";
import BookingSection from "@/components/BookingSection";
import Footer from "@/components/Footer";
import QuoteModal from "@/components/QuoteModal";

export default function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const openQuote = () => setQuoteOpen(true);

  return (
    <div className="min-h-screen overflow-x-hidden bg-navy-950 font-body text-slate-200 antialiased">
      <div className="grain-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-overlay" />
      <Navbar onQuote={openQuote} />
      <main>
        <Hero onQuote={openQuote} />
        <MarqueeStrip />
        <ServicesBento />
        <DualClimateMode />
        <ThermalSimulator />
        <StatsSection />
        <TestimonialsArea />
        <Gallery />
        <BookingSection />
      </main>
      <Footer onQuote={openQuote} />
      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}
